<template>
    <div class="page">
        <div class="title">请填写以下信息投诉卖家</div>
        <div class="small-title">非常抱歉给您带来不便，我们重视每一位用户的体验，请填写信息帮助我们明确问题。</div>
        <div class="view-box">
            <div class="text">投诉描述</div>
            <van-field
                v-model="dataForm.problemContent"
                rows="2"
                autosize
                type="textarea"
                class="textarea"
                maxlength="500"
                placeholder="请填写10字以上的投诉原因以便我们核实情况"
                show-word-limit
            />
        </div>
        <div class="view-box">
            <div class="text">图片证据<span>(选填)</span></div>
            <div class="text1">请上传与本次投诉相关的图片证据，您所上传的图片商家可见，请注意保护个人隐私！</div>
            <van-uploader multiple v-model="flieList" :max-count="1"/>
        </div>
        <div class="view-box">
            <div class="text">
                卡号<span>(必填)</span>
                <van-field v-model="dataForm.iccid" type="number" clear-trigger="always" class="ph-t" clearable placeholder="请输入卡号" />
            </div>
        </div>  
        <div class="view-box">
            <div class="text">
                手机号<span>(必填)</span>
                <van-field v-model="dataForm.userPhone" type="number" clear-trigger="always" class="ph-t" clearable placeholder="请输入手机号" maxlength="11" />
            </div>
        </div>  
        <div class="tick">
            <van-checkbox v-model="checked" shape="square" icon-size="16px"/>
            <div class="tick-name">同意商家客服获取投诉描述、图片证据和手机号码，以便联系您解决问题</div>
        </div>
        <div class="footer-btn">
            <van-button type="primary" style="background-color: #409eff;border-color:#409eff;" @click="customer">联系投诉客服</van-button>
            <van-button type="primary" @click="sumbit">提交</van-button>
        </div>
    </div>
</template>
<script>
import { Toast } from 'vant';
import { wxRequest } from '@/api/user'
export default{
    data(){
        return{
            kefuUrl: localStorage.getItem("kefuUrl"),
            dataForm:{
                problemContent:'',
                iccid:'',
                userPhone:''
            },
            flieList:[],
            checked:true,
        }
    },
    created(){
    },
    methods: {
        
        customer(){
            window.location.href=this.kefuUrl;
        },
        sumbit() {
            if(!(/^[1][3,4,5,7,8][0-9]{9}$/.test(this.dataForm.userPhone))){
                Toast.fail('请填写正确的手机号');
                return;
            }
            if(!this.dataForm.iccid){
                Toast.fail('请填写卡号');
                return;
            }
            if(!this.dataForm.problemContent){
                Toast.fail('请填写投诉信息');
                return;
            }
            let fd = new FormData();
            Object.keys(this.dataForm).forEach((key) => {
                fd.append(key, this.dataForm[key])
            });
            if(this.flieList.length > 0){
                fd.append("title",  this.flieList[0].file)
            }
           
            wxRequest("/userProblem/add/img", fd, "post").then(res => {
                if(res.data.code === '200'){
                    localStorage.setItem('myIccid',this.dataForm.iccid)
                    Toast.success('投诉成功！预计三个工作日内联系您处理'); 
                    this.$router.push({
                        path: "/user/complaintHistory",
                    }); 
                }else{
                    Toast.fail(res.data.message); 
                }
            })
        },
    },
}
</script>
<style lang="less" scoped>
div{
    display: flex;
    flex-grow: 0;
    flex-basis: auto;
    align-items: stretch;
    flex-direction: column;
}
.page{
	background: #f7f8fa;
    .title{
        font-size: 26px;
        font-weight: 800;
        color: #06121e;
        padding: 15px
    }
    .small-title{
        font-size: 14px;
        font-weight: 400;
        color: #8c9198;
        padding: 5px 15px 15px;
        line-height: 22px;
    }
    .view-box{
        padding: 10px 15px;
        background: #fff;
        margin-top: 10px;
        .text{
            font-size: 16px;
            font-weight: 800;
            color: #06121e;
            align-items: center;
            flex-direction: row;
            span{
                font-size: 16px;
                font-weight: 400;
                color: #999;
                margin: 0 5px;
            }
        }
        .text1{
            font-size: 14px;
            font-weight: 400;
            color: #bdc4ce;
            margin-top: 10px;
        }
        .textarea{
            min-height:150px;
            ::v-deep .van-field__body{
                height:94%;
                .van-field__control{
                    height:100% !important;
                }
            }
        }
        .van-uploader{
            margin: 6px;
        }
        .ph-t{
            padding-left: 10px;
            flex: 1 1 0%;
        }
    }
    .tick{
        flex-direction: row;
        padding: 15px;
        margin-bottom: 15px;
        .tick-name{
            font-size: 14px;
            font-weight: 400;
            color: #8c9198;
            line-height: 24px;
        }
        .van-checkbox{
            width:26px;
            margin-top:4px;
        }
    }
    .footer-btn{
        flex-direction: row;
        align-items: center;
        margin-bottom: 20px;
        .van-button{
            width:40%;
            margin-left:7%;
        }
    }
}
</style>
